import React from "react";
import { Link } from 'react-scroll';

export default function Services() {
  return (
    <div id="services" class="min-h-screen relative mb-16">
      <div class="w-8/12 flex flex-col mx-auto">
        <div class="flex">
          <div class="w-4/12 flex">
            <div class="text-primary">
              <div class="h-80 bg-100% bg-center" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/service_coordination.jpg)` }}></div>
              <div>
                <div class="mt-3 mb-3.5 text-center">
                  <span>Wedding Day Coordination</span>
                </div>
                <div class="text-center">
                  <span class="text-xs">
                    The ideal package for the couple who has everything planned and just need someone to take care of the remaining details leading up to the big day. We step in three months before to tie all loose ends together with a wedding day checklist, detailed timeline, and vendor coordination. Upon hiring, I will be available by phone or email as a consultant for your wedding planning.
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="w-4/12 flex mx-1.5">
            <div class="text-primary">
              <div class="h-80 bg-100% bg-center" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/service_partial.jpg)` }}></div>
              <div>
                <div class="mt-3 mb-3.5 text-center">
                  <span>Partial Planning</span>
                </div>
                <div class="text-center">
                  <span class="text-xs">
                    The perfect package for the busy couple who semi-know what they want their wedding to look like, but just don’t have time to plan everything on their own! We step in halfway through the wedding planning process after the main vendors are booked and assist with advising you on the best methods to achieve your unique ideas for your wedding day. We’re here to make the whole wedding planning process easier for you!
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="w-4/12 flex">
            <div class="text-primary">
              <div class="h-80 bg-cover bg-center" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/service_full.jpg)` }}></div>
              <div>
                <div class="mt-3 mb-3.5 text-center">
                  <span>Full Planning</span>
                </div>
                <div class="text-center">
                  <span class="text-xs">
                    The complete package for the couple who just got engaged and have no idea where to start, or simply don’t want to stress over wedding planning details on their own. We guide you throughout the entire wedding planning process from conception to execution. We’ve got you covered from the beginning to the end.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-primary mt-6">
          <div class="text-center mb-6">
            <span>Ala Carte & Special Events</span>
          </div>
          <div class="mb-8 text-center">
            <span class="text-xs">Don’t see a package that best fits your needs? We offer customized packages that are unique to the needs of your events. Inquire to learn more!</span>
          </div>
          <div class="w-full flex justify-center">
            <Link to="contact" smooth={true} offset={-75}>
              <button class="inline-flex mx-auto bg-button py-4 px-8 rounded-full">
                <span class="uppercase text-primary text-xs">
                  Inquire Now
                </span>
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
